import { bootBlock } from '../../src/js/blockRuntime';

const blogNewsletter = {
    init: function(root, { isEditor }) {
        const newsletter = root.querySelector('.newsletter-blog');

        // Editor: the page layout this adapts to does not exist in the canvas, and the form must not
        // subscribe anyone; the preview keeps the form's own markup and input behavior.
        if( newsletter && !isEditor ) {
            this.style(newsletter);
            this.takeoverFormOperation();
        }
    },
    takeoverFormOperation: () => {
        const form = document.querySelector('.newsletter-blog form');

        form.addEventListener('submit', e => {
            e.preventDefault();

            grecaptcha.ready(function () {
                grecaptcha.execute(recaptcha.recaptcha_widget_id, { action: 'submit' })
                    .then(function (token) {
                        document.getElementById('g-recaptcha-response-newsletter').value = token;

                        const ajax_data = {
                            action: 'join-newsletter',
                            email: document.querySelector('.newsletter-blog form input[type="email"]').value,
                            recaptchaToken: token,
                        };

                        const loader = document.querySelector('.newsletter-blog').nextElementSibling;

                        jQuery.ajax(
                            {
                                type: 'POST',
                                url: main_ajax.ajax_url,
                                data: ajax_data,
                                beforeSend: function() {
                                    loader?.classList.add('var_active');
                                },
                                success(data) {
                                    const json = JSON.parse(data.results)

                                    if ( typeof json.inlineMessage !== 'undefined' ) {
                                        const message = document.querySelector('.newsletter-blog__callback p');
                                        const newsletter = document.querySelector('.newsletter-blog');

                                        message.innerHTML = json.inlineMessage;

                                        newsletter.classList.add('var_message');
                                    }
                                },
                                error(xhr, status, errorThrown) {
                                    console.log(status, 'Custom ajax status', errorThrown, 'Custom ajax error');
                                },
                                complete: function() {
                                    loader?.classList.remove('var_active');
                                }
                            },
                        );
                    });
            });
        })
    },
    style: newsletter => {
        const lastMainChild = document.querySelector('main .content-wrapper').lastElementChild;

        const isLastChildContainsBackground = /background/.test(lastMainChild.className)

        if ( isLastChildContainsBackground ) {
            newsletter.classList.add('var_no-margin');
            lastMainChild.classList.add('var_padding-bottom');
        }
    }
}

bootBlock('blog-newsletter', (root, options) => blogNewsletter.init(root, options));
